import { CustomisedValues } from '@atlassian/cssxp-typescommon';
import { PromotionDuration } from '@atlassian/cssxp-types-promotion';
import { SelectPromotionSelectItem, SelectPromotionSelectItemV2 } from '@css-xp/base';
import { Benefit } from '@css-xp/graphtypes';
import { defaultTo, toNumber } from 'lodash';
import { Promotion } from '@css-xp/graphtypes/src/generated-types-new';

interface PromotionModifier {
  promotionSelectItem: SelectPromotionSelectItem;
  customReason?: {
    value: string | undefined | null;
    label: string | undefined | null;
  };
  customValue?: number;
  customDuration?: {
    value: string | undefined | null;
    label: string | undefined | null;
  };
  customIterations?: number;
}

export const promotionAddModifier = ({
  promotionSelectItem,
  customDuration,
  customReason,
  customValue,
  customIterations,
}: PromotionModifier) => {
  let customisedValues: CustomisedValues | null = null;
  if (promotionSelectItem?.promotion?.isPromotionCustomisable) {
    const duration = customDuration?.value || promotionSelectItem?.promotion?.benefits?.[0]?.duration || undefined;
    customisedValues = {
      applicationReason: {
        id: customReason?.value || promotionSelectItem?.promotion?.applicationReason?.id || '',
      },
      benefits: [
        {
          value: customValue || promotionSelectItem?.promotion?.benefits?.[0]?.value || undefined,
          duration: customDuration?.value || promotionSelectItem?.promotion?.benefits?.[0]?.duration || undefined,
          iterations:
            duration === PromotionDuration.REPEATING
              ? customIterations || promotionSelectItem?.promotion?.benefits?.[0]?.iterations || undefined
              : undefined,
        },
      ],
    };
  }

  const addPromotions = [
    {
      promotionDefinition: {
        promotionId: promotionSelectItem?.value,
        customisedValues: customisedValues ?? null,
      },
    },
  ];

  return addPromotions;
};

interface CustomValues {
  value: string;
  label: string;
}
export interface PromotionFormData {
  promotionId?: SelectPromotionSelectItemV2;
  customDuration?: CustomValues[];
  customIterations?: string[] | null[];
  customReason?: CustomValues[];
  customValue?: string[] | number[];
  supportTicketLink?: string | null;
  handNote?: string | null;
  comments?: string;
  promoCode?: string;
  partnerPromotion?: Promotion | null;
}

export const getCustomPromotionInstance = (index: number, formData: any) => {
  const customkey = `customPromotionId-${index}`;
  //@ts-ignore
  const customPromotionId = formData[customkey]?.value;
  const benefit: Benefit = {};
  if (customPromotionId) {
    benefit.duration = defaultTo(formData.customDuration?.[index]?.value, '');
    benefit.iterations = toNumber(defaultTo(formData.customIterations?.[index], undefined));
    benefit.value = toNumber(defaultTo(formData.customValue?.[index], undefined));
  }
  return {
    promotionInstanceId: null,
    promotionDefinition: {
      promotionId: customPromotionId,
      customisedValues: !customPromotionId
        ? null
        : {
            applicationReason: {
              id: defaultTo(formData.customReason?.[index]?.value, ''),
            },
            benefits: [
              {
                ...benefit,
              },
            ],
          },
    },
  };
};
